var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTrashGreen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 24,
    viewBox: "0 0 21 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.29688 2.25C8.15625 2.25 8.0625 2.34375 7.96875 2.4375L7.07812 3.75H13.875L12.9844 2.4375C12.9375 2.34375 12.7969 2.25 12.6562 2.25H8.29688ZM16.5938 3.75H17.2031H19.5H19.875C20.4844 3.75 21 4.26562 21 4.875C21 5.53125 20.4844 6 19.875 6H19.3125L18.1875 21.2344C18.0469 22.8281 16.7812 24 15.1875 24H5.76562C4.17188 24 2.90625 22.8281 2.76562 21.2344L1.64062 6H1.125C0.46875 6 0 5.53125 0 4.875C0 4.26562 0.46875 3.75 1.125 3.75H1.5H3.75H4.35938L6.09375 1.17188C6.5625 0.46875 7.40625 0 8.29688 0H12.6562C13.5469 0 14.3906 0.46875 14.8594 1.17188L16.5938 3.75ZM17.0625 6H3.89062L5.01562 21.0938C5.0625 21.4688 5.39062 21.75 5.76562 21.75H15.1875C15.5625 21.75 15.8906 21.4688 15.9375 21.0938L17.0625 6Z",
    fill: "#006D5B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrashGreen);
export default __webpack_public_path__ + "static/media/trashGreen.7ad293ee1f6f663681a2aa6da5ba3986.svg";
export { ForwardRef as ReactComponent };